// extracted by mini-css-extract-plugin
export var orderSummary = "_t7-0";
export var showMoreLessButton = "_t7-1";